export const AREA_ID_DOMESTIC = 1;

export const TAKAFUL = 'takaful';
export const INSURANCE = 'insurance';

export const EGTB = 'EGTB';
export const EGIB = 'EGIB';

export const PROD_HOST = 'edp';

export const DISCOUNT_RATE = '25%';

export const STAMP_DUTY = 10;
export const CHANGE_STAMP_DUTY_PRICE = 150;

export const PRODUCT_NAME = 'TripCare 360';
export const ITEM_NAME = 'tripcare_360';
export const GA_INSURANCE = 'Insurance';
export const GA_TAKAFUL = 'Takaful';

export const AMLA_ERROR_PREFIX = ['APPAMLA', 'AML', 'TRN', 'IBMDM'];

export const MALAYSIAN = 136;
export const UNITED_STATES = 5;

export const MAXIMUM_ADULT_GROUP = 21;
export const MINIMUM_ADULT_GROUP = 2;

export const MAXIMUM_ADULT_FAMILY = 2;
export const MINIMUM_ADULT_FAMILY = 1;
export const MAXIMUM_CHILDREN_FAMILY = 10;
export const MINIMUM_CHILDREN_FAMILY = 1;

export const MAINTENANCEDATE = 'MaintenanceDate';
export const MAINTENANCETIME = 'MaintenanceTime';

export const PF_NUMBER_LENGTH = 8;

export const PH_PAY_MODE = 'PAYMONGO';

export const SOURCEAPP_ECHANNEL = 1;

export const SOURCEAPP_GOTGAFFILIATE = 6;
